import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n";

const AREAS = [
  { href: "/ncc-santa-teresa-gallura", label: "NCC Santa Teresa Gallura", testid: "footer-area-sts" },
  { href: "/ncc-olbia", label: "NCC Olbia", testid: "footer-area-olbia" },
  { href: "/ncc-palau", label: "NCC Palau", testid: "footer-area-palau" },
  { href: "/ncc-cannigione", label: "NCC Cannigione", testid: "footer-area-cannigione" },
  { href: "/ncc-baja-sardinia", label: "NCC Baja Sardinia", testid: "footer-area-baja" },
  { href: "/ncc-bonifacio", label: "Transfer Bonifacio", testid: "footer-area-bonifacio" },
];

export default function Footer() {
  const { t, lang } = useI18n();
  return (
    <footer data-testid="footer" className="bg-[#0A2463] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 bg-white rounded-xl grid place-items-center overflow-hidden">
              <img
                src="/logo-mark.png"
                alt="Gallura Drive"
                className="w-10 h-10 object-contain"
                width="40"
                height="40"
              />
            </div>
            <span className="font-display text-xl">Gallura Drive</span>
          </div>
          <p className="text-sm text-white/70 mt-4 max-w-xs">{t.footer.tagline}</p>
        </div>

        <div className="text-sm text-white/70">
          <div className="uppercase tracking-widest text-xs text-white/50">
            {lang === "it" ? "Contatti" : "Contact"}
          </div>
          <div className="mt-3">+39 347 001 1246</div>
          <div>info@galluradrive.it</div>
          <div className="mt-2">Olbia — Costa Smeralda, Sardegna</div>
        </div>

        <div className="text-sm text-white/70">
          <div className="uppercase tracking-widest text-xs text-white/50">
            {lang === "it" ? "Zone servite" : "Service areas"}
          </div>
          <ul className="mt-3 space-y-2">
            {AREAS.map((a) => (
              <li key={a.href}>
                <Link
                  to={a.href}
                  data-testid={a.testid}
                  className="hover:text-white transition-colors"
                >
                  {a.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="text-sm text-white/70">
          <div className="uppercase tracking-widest text-xs text-white/50">Legal</div>
          <div className="mt-3">P.IVA 01234567890</div>
          <div>Comune di Olbia</div>
          <div className="mt-3 space-x-3">
            <Link to="/terms" data-testid="footer-terms-link" className="underline hover:text-white">
              {lang === "it" ? "Termini" : "Terms"}
            </Link>
            <Link to="/privacy" data-testid="footer-privacy-link" className="underline hover:text-white">
              Privacy
            </Link>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/50">
        © {new Date().getFullYear()} Gallura Drive — {t.footer.rights}
      </div>
    </footer>
  );
}
